<template>
    <div v-if="item.type === 'IMAGE'">
        <img width="100px" class="img-thumbnail" :src="baseUrl + item.value" alt="Card image cap"/>
    </div>
    <div v-else-if="item.type === 'HTML'" v-html="item.value">
        {{item.value}}
    </div>
    <div v-else-if="item.type === 'DATE'">
        {{item.value | moment("DD.MM.YYYY") }}
    </div>
    <div v-else-if="item.type === 'DESIGN_SHOP_TILE'">
        <img width="100px" class="img-thumbnail" :src="fileResourceUrl(item.value.image)" alt="Card image cap"/>
    </div>
    <div v-else-if="item.type === 'TREND_SHOP_TILE'">
        <img width="100px" class="img-thumbnail" :src="fileResourceUrl(item.value.image)" alt="Card image cap"/>
    </div>
    <div v-else-if="item.type === 'DESIGN_SHOP_TILE_LIST'">
        <ul>
            <li v-bind:key="index" v-for="(tile,index) in $_.orderBy(item.value, ['sort'],['asc'])">{{tile.label}}</li>
        </ul>
    </div>
    <div v-else>
        {{item.value}}
    </div>
</template>

<script>
    import {config} from "@shared/_services/config";

    export default {
        name: "value-render",
        props: {item: Object},
        data() {
            return {
                baseUrl: config.baseUrl + config.resourceUrl
            }
        },

    }
</script>